<!-- @format -->

<template>
	<div v-if="order" class="white" style="color: black">
		<v-container fluid style="max-width: 1200px">
			<div class="d-flex ba block w-100 mb-1">
				<div style="width: 200px; height: 110px" class="br">
					<img height="100" class="mt-2 mx-auto" contain src="@/assets/lusazu_logo.png" />
				</div>
				<div style="flex: 3" class="align-self-center">
					<div class="text-h4 font-weight-bold">
						CERTIFICADO DE SERVICIOS
					</div>
				</div>
				<div style="flex: 1" class="bl">
					<div class="font-weight-medium text-h5">Resolucion Sanitaria</div>
					<div class="font-weight-medium body-1 font-weight-bold">
						Nº 7776-10-2019
					</div>
					<div class="font-weight-medium body-1 font-weight-bold">ISO 9001</div>
				</div>
			</div>
			<div class="text-left bb d-flex justify-space-between align-center">
				<div>
					<div class="body-2">
						REPRESENTANTE LEGAL: Luis Hernán Salazar Zuazo / RUT: 10.511.968-2
					</div>
					<div class="body-2">Calle Santa Lucia Nº 103 - Graneros</div>
					<div class="body-2">TELÉFONOS: +56 9 9638 3844</div>
				</div>
				<div class="title font-weight-bold">№ S/D {{ order.id }}</div>
			</div>
			<div class="d-flex mt-2">
				<div style="flex: 1" class="bb d-flex align-center text-left">
					<div style="width: 70px" class="text-uppercase body-1 mr-2">
						Fecha:
					</div>
					<div style="width: 100%">{{ order.data[0] }}</div>
				</div>
				<div style="flex: 1" class="bb d-flex align-center text-left">
					<div style="width: 200px" class="text-uppercase body-1 mr-2">
						HORA INICIO:
					</div>
					<div style="width: 100%">{{ order.startHour }}</div>
				</div>
				<div style="flex: 1" class="bb d-flex flex-no-wrap align-center text-left">
					<div style="width: 250px" class="text-uppercase body-1 mr-2">
						HORA TERMINO:
					</div>
					<div style="width: 100%">{{ order.endHour }}</div>
				</div>
			</div>
			<div class="d-flex align-center text-left mt-2">
				<div style="flex: 1" class="d-flex align-center">
					<label for="programados">
						SERVICIOS PROGRAMADOS
					</label>
					<input
						id="programados"
						class="ml-2"
						v-model="order.data[3]"
						style="width: 15px"
						type="checkbox"
					/>
				</div>
				<div style="flex: 1" class="d-flex align-center">
					<label for="extras">
						SERVICIOS EXTRAS
					</label>
					<input
						id="extras"
						class="ml-2"
						v-model="order.data[4]"
						style="width: 15px"
						type="checkbox"
					/>
				</div>
				<div style="flex: 1" class="d-flex align-center">
					<label for="otros">
						OTROS
					</label>
					<input
						id="otros"
						class="ml-2"
						v-model="order.data[5]"
						style="width: 15px"
						type="checkbox"
					/>
				</div>
			</div>
			<div class="d-flex mt-2">
				<div style="flex: 1" class="bb d-flex flex-no-wrap align-center text-left">
					<div style="width: 70px" class="text-uppercase body-1 mr-2">
						CLIENTE:
					</div>
					<div style="width: 100%">{{ order.data[6] }}</div>
				</div>
				<div style="flex: 1" class="bb d-flex flex-no-wrap align-center text-left">
					<div style="width: 70px" class="text-uppercase body-1 mr-2">
						PLANTA:
					</div>
					<div style="width: 100%">{{ order.data[7] }}</div>
				</div>
			</div>
			<div style="flex: 2" class="bb d-flex flex-no-wrap align-center text-left">
				<span class="text-uppercase body-1 mr-2">
					Dirección:
				</span>
				<span>{{ order.data[8] }}</span>
			</div>
			<div class="d-flex">
				<div style="flex: 2" class="bb d-flex flex-no-wrap align-center text-left">
					<span class="text-uppercase body-1 mr-2">
						Nombre solicitante:
					</span>
					<span>{{ order.data[9] }}</span>
				</div>
				<div style="flex: 2" class="bb d-flex flex-no-wrap align-center text-left">
					<span class="text-uppercase body-1 mr-2">
						RUT solicitante:
					</span>
					<span>{{ order.data[10] }}</span>
				</div>
			</div>
			<div style="flex: 2" class="bb d-flex flex-no-wrap align-center text-left">
				<span class="text-uppercase body-1 mr-2">
					Responsable planta:
				</span>
				<span>{{ order.data[11] }}</span>
			</div>
			<div style="flex: 2" class="bb d-flex flex-no-wrap align-center text-left">
				<span class="text-uppercase body-1 mr-2">
					Tecnico responsable del trabajo:
				</span>
				<span>{{ order.data[12] }}</span>
			</div>
			<div class="title my-2 bb">
				SERVICIOS REALIZADOS
			</div>
			<div class="d-flex align-start">
				<div style="flex: 1">
					<div class="d-flex align-center justify-start">
						<label for="sanitizacion">
							<span class="mr-2 font-italic body-1 text-uppercase">
								SANITIZACIÓN
							</span>
						</label>
					</div>
					<div class="text-left d-flex flex-wrap">
						<div style="width: 100%" class="text-left mt-3 mb-2">
							<span style="font-size:16px; font-weight:bold;">
								Areas Tratadas (desinfectadas)
							</span>
						</div>
						<label for="data113" style="width: 60%">BANOS</label>
						<div style="width: 25%">
							<input
								id="data113"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[113]"
							/>
						</div>
						<label for="data13" style="width: 60%">BANOS DE SERVICIOS</label>
						<div style="width: 25%">
							<input
								id="data13"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[13]"
							/>
						</div>
						<label for="data14" style="width: 60%">BANOS ADMINISTRATIVOS</label>
						<div style="width: 25%">
							<input
								id="data14"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[14]"
							/>
						</div>
						<label for="data15" style="width: 60%">CAMARINES</label>
						<div style="width: 25%">
							<input
								id="data15"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[15]"
							/>
						</div>
						<label for="data16" style="width: 60%">DUCHAS</label>
						<div style="width: 25%">
							<input
								id="data16"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[16]"
							/>
						</div>
						<label for="data17" style="width: 60%">CASINO</label>
						<div style="width: 25%">
							<input
								id="data17"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[17]"
							/>
						</div>
						<label for="data18" style="width: 60%">BODEGA</label>
						<div style="width: 25%">
							<input
								id="data18"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[18]"
							/>
						</div>
						<label for="data19" style="width: 60%">PRE FRIOS</label>
						<div style="width: 25%">
							<input
								id="data19"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[19]"
							/>
						</div>
						<label for="data20" style="width: 60%">CAMARAS</label>
						<div style="width: 25%">
							<input
								id="data20"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[20]"
							/>
						</div>
						<label for="111" style="width: 60%">OFICINAS</label>
						<div style="width: 25%">
							<input
								id="data111"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[111]"
							/>
						</div>
						<label for="data115" style="width: 60%">PATIO (exterior)</label>
						<div style="width: 25%">
							<input
								id="data115"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[115]"
							/>
						</div>
						<div class="bb" style="width: 65%">
							<label for="data21">OTROS</label>
							<input
								id="data21"
								type="text"
								style="width: 75%"
								v-model="order.data[21]"
							/>
						</div>
					</div>
				</div>
				<div style="flex: 1">
					<div class="d-flex align-center text-left body-1 text-uppercase">
						Productos Utilizados
					</div>
					<div class="text-left d-flex flex-wrap">
						<!-- #1 -->
						<input
							id="sani1"
							type="checkbox"
							style="width: 15px;"
							v-model="order.data[22][0]"
						/>
						<label
							for="sani1"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>SANICITREX</b> / SANITIZANTE NATURAL A BASES DE CITRICOS /
							<br />
							ISP: D-19/23
							<br />Dosis: 80 CC/ 10 Litro de agua
						</label>
						<!-- #2 -->
						<input
							id="sani2"
							type="checkbox"
							style="width: 15px;"
							v-model="order.data[22][1]"
						/>
						<label
							for="sani2"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>DRAYCUAT PLUS</b> / SALES DE AMONIO CUATERNARIO DE V GENERACION AL
							15%
							<br />
							ISP: D-204/21 <br />Dosis: 90 A 100 CC X 10 LITROS AGUA - SANITIZACION
							SEVERAS
						</label>
						<!-- #3 -->
						<input
							id="sani3"
							type="checkbox"
							style="width: 15px;"
							v-model="order.data[22][3]"
						/>
						<label
							for="sani3"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>Dryquat 250 SL</b> / Cloruro de Benzalconio 2,5%
							<br />
							ISP: D-204/16 <br />Dosis: 30 cc/Litros de agua
						</label>
						<!-- #4 -->
						<input
							id="sani4"
							type="checkbox"
							style="width: 15px;"
							v-model="order.data[22][4]"
						/>
						<label
							for="sani4"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>Decutec</b> / Amonio cuaternario 1% - Nano Particulas Cobre 0,2%
							<br />
							ISP: D-1039/20 <br />Dosis: 15 CC/ Metro Cuadrado
						</label>
						<!-- #5 -->
						<input
							id="sani5"
							type="checkbox"
							style="width: 15px;"
							v-model="order.data[22][5]"
						/>
						<label
							for="sani5"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>Cupex</b> / Etanol 70 % - Nano Cobre 1000 ppm
							<br />
							ISP: <br />Dosis: 15 CC/ Metro Cuadrado
						</label>
						<!-- #6 -->
						<input
							id="sani6"
							type="checkbox"
							style="width: 15px;"
							v-model="order.data[22][6]"
						/>
						<label
							for="sani6"
							style="width: 95%; padding-left:10px;"
							class="text-uppercase"
						>
							<b>Dryquat 250 SL</b> / Cloruro de Benzalconio 2,5%
							<br />
							ISP: D-204/16<br />Dosis: 5 cc/Litros de agua
						</label>
					</div>
					<div
						v-if="order.data[22][2] && order.data[22][2].nombre"
						class="text-left d-flex"
					>
						<input
							id="des8"
							type="checkbox"
							style="width: 15px"
							v-model="order.data[22][2]"
						/>
						<label for="des8" style="width: 95%; padding-left:10px;">
							<b>{{ order.data[22][2].nombre }} </b>{{ order.data[22][2].detalle }}/
							Registro ISP: {{ order.data[22][2].isp }} /
							{{ order.data[22][2].dosis }}
						</label>
					</div>
				</div>
			</div>
			<div class="text-left my-2">
				<div class="text-uppercase caption">Observaciones: {{ order.data[23] }}</div>
			</div>
			<div class="d-flex align-start mt-1">
				<div style="flex: 1">
					<div class="d-flex align-center ">
						<label for="desinsectacion">
							<span class="mr-2 font-italic body-1 text-uppercase">
								DESINSECTACIÓN
							</span>
						</label>
					</div>
					<div class="text-left">
						<span style="font-size:16px; font-weight:bold;">Areas Tratadas</span>
					</div>
					<div class="text-left d-flex flex-wrap mt-3">
						<label for="data24" style="width: 60%">BODEGAS</label>
						<div style="width: 25%">
							<input
								id="data24"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[24]"
							/>
						</div>
						<label for="data25" style="width: 60%">CAMARAS</label>
						<div style="width: 25%">
							<input
								id="data25"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[25]"
							/>
						</div>
						<label for="data26" style="width: 60%">PATIO(exterior)</label>
						<div style="width: 25%">
							<input
								id="data26"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[26]"
							/>
						</div>
						<label for="data116" style="width: 60%">OFICINAS</label>
						<div style="width: 25%">
							<input
								id="data116"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[116]"
							/>
						</div>
						<label for="data117" style="width: 60%">CASINO</label>
						<div style="width: 25%">
							<input
								id="data117"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[117]"
							/>
						</div>
						<label for="data118" style="width: 60%">BANOS</label>
						<div style="width: 25%">
							<input
								id="data118"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[118]"
							/>
						</div>
						<label for="data122" style="width: 60%">BANOS DE SERVICIOS</label>
						<div style="width: 25%">
							<input
								id="data122"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[122]"
							/>
						</div>
						<label for="data123" style="width: 60%">BANOS ADMINISTRATIVOS</label>
						<div style="width: 25%">
							<input
								id="data123"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[123]"
							/>
						</div>
						<label for="data124" style="width: 60%">CAMARINES</label>
						<div style="width: 25%">
							<input
								id="data124"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[124]"
							/>
						</div>
						<label for="data125" style="width: 60%">DUCHAS</label>
						<div style="width: 25%">
							<input
								id="data125"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[125]"
							/>
						</div>
						<label for="data126" style="width: 60%">PRE FRIOS</label>
						<div style="width: 25%">
							<input
								id="data126"
								style="width: 15px"
								type="checkbox"
								v-model="order.data[126]"
							/>
						</div>
						<div class="bb" style="width: 65%">
							<label for="data27">OTROS</label>
							<input
								id="data27"
								type="text"
								style="width: 75%"
								v-model="order.data[27]"
							/>
						</div>
					</div>
				</div>
				<div style="flex: 1">
					<div class="mt-3 mt-0 d-flex align-center text-left body-1 text-uppercase">
						Productos Utilizados
					</div>
					<div class=" text-left d-flex">
						<input
							type="checkbox"
							id="des0"
							style="width: 15px"
							v-model="order.data[28][0]"
						/>
						<label for="des0" style="width: 95%;" class="text-left mb-2">
							<div style="width: 80%; padding-left:10px;">
								<b>Cyperkill plus </b> Cipermetrina 25,0% critico desinfectante 10g/
								Transtertrametrina 15% EC Registro ISP: P-407/1 / Dosis 20-25 cc x 5
								lts de agua
							</div>
						</label>
					</div>
					<div class="text-left d-flex">
						<input
							id="des1"
							type="checkbox"
							style="width: 15px"
							v-model="order.data[28][1]"
						/>
						<label for="des1" style="width: 95%; padding-left:10px;">
							<b>Actellic 50 EC </b> Pirlmifos.metil al 50% / Registro ISP: P-0027/98
						</label>
					</div>
					<div class="  text-left d-flex">
						<input
							id="des3"
							type="checkbox"
							style="width: 15px"
							v-model="order.data[28][3]"
						/>
						<label for="des3" style="width: 95%; padding-left:10px;">
							<b>Temprid sc </b> Imidacloprid 21%p/p + betaciflutrina 10,5% pp /
							Registro ISP: P-715/14 / Dosis 2-4 cc/lts de agua
						</label>
					</div>
					<div class="  text-left d-flex">
						<input
							id="des4"
							type="checkbox"
							style="width: 15px"
							v-model="order.data[28][4]"
						/>
						<label for="des4" style="width: 95%; padding-left:10px;">
							<b>Demand sc</b> Lamda cihalotrina 2,5 g / Registro ISP: P-674/19 /
							Dosis 10 cc/ lts de agua
						</label>
					</div>
					<div class="  text-left d-flex">
						<input
							id="des5"
							type="checkbox"
							style="width: 15px"
							v-model="order.data[28][5]"
						/>
						<label for="des5" style="width: 95%; padding-left:10px;">
							<b>Blattanex </b> Imidacloprida 2,15%p/p / Registro ISP: P-670/18 /
							Dosis 2 gotas por mts 2
						</label>
					</div>
					<div class="  text-left d-flex">
						<input
							id="des6"
							type="checkbox"
							style="width: 15px"
							v-model="order.data[28][6]"
						/>
						<label for="des6" style="width: 95%; padding-left:10px;">
							<b>Cyperkill 25 EC</b> Cipermetrina 25% EC / Registro ISP: P-101/19 /
							Dosis 8cc/lts de agua
						</label>
					</div>
					<div class="  text-left d-flex">
						<input
							id="des7"
							type="checkbox"
							style="width: 15px"
							v-model="order.data[28][7]"
						/>
						<label for="des7" style="width: 95%; padding-left:10px;">
							<b>Bell </b> Imidacloprid 2,15%p/p / Registro ISP: P-670/18 / Dosis 2
							gotas por mts 2
						</label>
					</div>
					<div class="  text-left d-flex">
						<input
							id="des8"
							type="checkbox"
							style="width: 15px"
							v-model="order.data[28][8]"
						/>
						<label for="des8" style="width: 95%; padding-left:10px;">
							<b>Advion </b> Indoxacarb 0,6 grs / Registro ISP: P-800/17 / Dosis 3
							gotas cada 3 mt s lineales
						</label>
					</div>
					<div
						v-if="order.data[28][2] && order.data[28][2].nombre"
						class="text-left d-flex"
					>
						<input
							id="des8"
							type="checkbox"
							style="width: 15px"
							v-model="order.data[28][2]"
						/>
						<label for="des8" style="width: 95%; padding-left:10px;">
							<b>{{ order.data[28][2].nombre }} </b>{{ order.data[28][2].detalle }}/
							Registro ISP: {{ order.data[28][2].isp }} /
							{{ order.data[28][2].dosis }}
						</label>
					</div>
				</div>
			</div>
			<div class="text-left font-weight-bold body-1">
				EQUIPOS LUZ ULTRAVIOLETA
			</div>
			<div class="d-flex">
				<div style="flex: 1" class="mr-10 text-left">
					<div class="mb-1 d-flex justify-space-between">
						<span>NUMERO DE EQUIPOS UV INSTALADOS</span>
						<div style="width: 20%" class="ba pl-1">{{ order.data[29] }}</div>
					</div>
					<div class="mb-1 d-flex justify-space-between">
						<span>NUMERO DE EQUIPOS UV FUNCIONANDOS</span>
						<div style="width: 20%" class="ba pl-1">{{ order.data[31] }}</div>
					</div>
					<div class="mb-1 d-flex justify-space-between">
						<span>NUMERO DE EQUIPOS UV DEFECTUOSOS</span>
						<div style="width: 20%" class="ba pl-1">{{ order.data[33] }}</div>
					</div>
				</div>
				<div style="flex: 1" class="ml-10 text-left">
					<div class="mb-1 d-flex ">
						<div style="width: 20%" class="ba pl-1 mr-2">{{ order.data[30] }}</div>
						<span>LIMPIEZA DE EQUIPOS</span>
					</div>
					<div class="mb-1 d-flex ">
						<div style="width: 20%" class="ba pl-1 mr-2">{{ order.data[32] }}</div>
						<span>CAMBIO DE LAMINA PEGAJOSA</span>
					</div>
					<div class="mb-1 d-flex ">
						<div style="width: 20%" class="ba pl-1 mr-2">{{ order.data[34] }}</div>
						<span>CAMBIO DE TUBO UV</span>
					</div>
				</div>
			</div>
			<div class="my-2 text-left">
				<div class="text-uppercase caption">Observaciones: {{ order.data[35] }}</div>
			</div>
			<div class="d-flex justify-space-between">
				<div>
					<div class="bb text-left">
						<span style="width: 30%" class="text-uppercase body-1">
							Cliente:
						</span>
						<span class="body-2 text-capitalize" v-if="order.cliente">
							{{ order.cliente.nombre }} RUT: {{ order.cliente.rut }}
						</span>
					</div>
					<v-img height="150" eager contain :src="order.firma" alt="firma" />
					<span style="font-size: 19px">www.lusazu.cl</span>
				</div>
				<div>
					<div class="bb text-left">
						<span style="width: 30%" class="text-uppercase body-1">
							Tecnico:
						</span>
						<span class="body-2 text-capitalize" v-if="order.datosTecnico">
							{{ order.datosTecnico.nombre }} RUT: {{ order.datosTecnico.rut }}
						</span>
					</div>
					<v-img height="150" eager contain :src="order.firmaTecnico" alt="firma" />
					<span style="font-size: 19px">info@lusazu.cl</span>
				</div>
			</div>
			<!-- End Form -->
			<!-- <div class="page-break"></div>
			<v-col v-if="images.length" cols="12">Antecedentes fotográficos:</v-col>
			<div style="width: 100%">
				<div class="d-flex flex-wrap" v-if="images.length">
					<div v-for="(img, key) in images" :key="key">
						<a target="_blank" :href="img.url">
							<v-img
								lazy-src="@/assets/placeholder.png"
								:src="img.url"
								class="mr-1 foto-antecedentes"
								alt="imagen de la orden"
							>
								<div class="bg caption text-right">{{ createAt(img._id) }}</div>
							</v-img>
						</a>
					</div>
				</div>
			</div> -->
		</v-container>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
export default {
	data() {
		return {
			order: null,
			images: undefined,
		};
	},
	created() {
		document.getElementById('viewport').setAttribute('content', 'max-width=950px');
	},
	async mounted() {
		const { workOrder, documents } = await this.getWorkOrder({
			idLodging: this.$route.params.idLodging,
			indexWorkOrder: this.$route.params.index,
		});
		this.order = workOrder;
		// Hay OT corruptas guardadas sin el array data.
		if (!Array.isArray(this.order.data)) this.order.data = [];
		// Las OT que nunca tocaron la seccion de productos guardan estos campos
		// en null, pero el template los indexa como arrays (data[22][n] / data[28][n]).
		[22, 28].forEach(index => {
			if (!Array.isArray(this.order.data[index])) this.order.data[index] = [];
		});
		if (this.order.data[103]) this.order.data[103] = this.order.data[103].split('\n');
		if (this.order.reco2) this.order.reco2 = this.order.reco2.split('\n');
		if (this.order.reco3) this.order.reco3 = this.order.reco3.split('\n');
		this.images = documents.filter(document => {
			const typeDocument = document.url.slice(-3);
			if (this.validateImage(typeDocument)) return true;
			return false;
		});
	},
	methods: {
		getObservaciones(observationType) {
			if (observationType) {
				if (this.order.data[21].customObservaciones.length)
					return this.order.data[21].customObservaciones;
			}
		},
		getRecomendaciones(observationType) {
			if (observationType) {
				if (this.order.data[21].customRecomendaciones.length)
					return this.order.data[21].customRecomendaciones;
			}
		},
		isToday(orderDate, datePhoto) {
			return moment(orderDate).isSame(datePhoto, 'day');
		},
		createAt(id) {
			if (id) return moment(this.dateFromObjectId(id)).format('lll');
			else return 'Sin fecha';
		},
		hasInfo(item) {
			return item !== 'Sin info';
		},
		dateFromObjectId(objectId) {
			return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
		},
		validateImage(typeDocument) {
			typeDocument = typeDocument.toLowerCase();
			if (typeDocument === 'jpg' || typeDocument === 'png' || typeDocument === 'peg')
				return true;
			return false;
		},
		formatWorkOrder(workOrder) {
			return workOrder.map(item => {
				if (item === null || item === false) return 'No';
				if (item === true) return 'Si';
				else return item;
			});
		},
		...mapActions({
			getWorkOrder: 'Lodging/getWorkOrder',
			getLodging: 'Lodging/getLodging',
		}),
	},
};
</script>

<style scoped>
input {
	height: 18px;
	border: none !important;
}
.nw {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.marca-agua {
	position: absolute;
	top: 40%;
	left: 30%;
	opacity: 0.1;
	z-index: 1;
}
/* I created this class in order to make smaller a particular  text */
.class-custom {
	font-size: 8px !important;
}
* {
	color: black;
	-webkit-print-color-adjust: exact !important;
	color-adjust: exact !important;
	font-size: 12px;
}
/* Tamaño pagina 1056 1392 px  */
@media print {
	@page {
		size: A3 portrait;
		width: 100%;
		margin: auto;
	}
	.firmas {
		max-height: 90px !important;
		height: 90px !important;
	}
	.antecedentes-fotograficos {
		display: none;
	}
	.border-ot {
		display: table;
		margin: 0 auto;
		border: 0px !important;
	}
	.page-break {
		display: block;
		page-break-before: always;
	}
}
.border-a {
	border-bottom: 2px solid gray !important ;
	margin-bottom: 2px;
	width: 98%;
	max-width: 1050px;
	height: 1300px;
}
.ba {
	border: 1px solid black;
}
.bl {
	border-left: 1px solid black;
}
.br {
	border-right: 1px solid black;
}
.bt {
	border-top: 1px solid black;
}
.bb {
	border-bottom: 1px solid black;
}
.bg {
	background-color: #0056c7;
}
.bg-secondary {
	background-color: #80bd00;
}
.cc {
	width: 30px;
	height: 15px;
}
.border-ot {
	background-color: white;
	margin: 5px auto;
	width: 100%;
	max-width: 1040px;
}
.foto-antecedentes {
	border-radius: 15px;
	margin-bottom: 50px;
	height: 200px;
	width: 200px;
	border: 1px solid black;
}

.text--color {
	color: rgba(0, 0, 0, 0.74);
}
input {
	pointer-events: none;
}
</style>
